import React from 'react'
import columns from './columns'
import store from '../store'
import Table from '@common/Table'

export default () => (
  <Table store={store} columns={columns} shouldGetListWhenDidMount={false} />
)
